import React, {Component} from 'react';
import {connect} from 'react-redux';
import validate from '../../utils/validate';

import * as spActions from '../../actions/sp';
import AppNames from "../AppNames/AppNames";
import '../index.scss';
import {checkSession} from "../../api/api";
import * as messageConstants from '../../shared/messages';
import Message from "../Message";
import duplicates from 'array-duplicates';
import {
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import {OIDC_APPLICATION} from "../../constants/applicationTypes.js";
import RedirectUris from "./RedirectUris/RedirectUris";
import ClientCredentials from "./ClientCredentials/ClientCredentials";
import ConfigurableWorkflow from "./ConfigurableWorkflow/ConfigurableWorkflow";
import PublicClient from './PublicClient/PublicClient';
import SingleLogout from './SingleLogout/SingleLogout';
import * as idpActions from "../../actions/idp";
import OidcIdpMetadataPopup from "./IdpOidcMetadataPopup/OidcIdpMetadataPopup";
import CapabilitiesSection from "../AddSAML/CapabilitiesSection";
import {getExtendedAttributes, getMappedCapabilities} from "../../actions/storage";
import Scope from "./Claims/Scope";
import {
  NON_LDAP_EPIC_USERNAME, SBA_WORKFLOW_MAPPING,
  SID_GUID_FLEXIBLE_ATTRIBUTES,
  USER_EXTENDED_ATTRIBUTES
} from "../../constants/requiredCapabilitiesMapping";
import {EXTENDED_ATTRIBUTE, REGULAR_USER_ATTRIBUTES} from "../../constants/samlConstants";
import {OIDC_WORKFLOW_NAME_EPCS} from "../../constants/oidcConstants";

export class OidcApp extends Component {
  state = {}
  handleFrameTasks = (e) => {
    console.log(e);
  }

  handleSaveSP = () => {
    let oidcProfile = null;

    if (this.props.oidcProfile && !this.state.spDataActive) {
      oidcProfile = this.props.oidcProfile;
    }
    oidcProfile.oidcRedirectUris = this.props.oidcRedirectUris.filter(
        e => e.redirectUri.length > 0);

    oidcProfile.oidcScope = this.props.oidcScope
        .map(scope => {
            let customClaims = scope.oidcCustomClaims
                .filter(claim => claim.oidcCustomClaimName.length > 0)
                .map(claim => {
                    if (!REGULAR_USER_ATTRIBUTES.includes(claim.idpUserAttributeEnum)) {
                        return {
                            ...claim,
                            "oidcCustomClaimValue": claim.idpUserAttributeEnum.toString(),
                            "idpUserAttributeEnum": EXTENDED_ATTRIBUTE
                        }
                    }
                    return claim;
                });
            return {
                ...scope,
                oidcCustomClaims: customClaims
            }
        }).filter(scope => scope.scopeName.length > 0 || scope.oidcCustomClaims.length > 0);
    const newMeta = {
      name: this.props.applicationName,
      userFriendlyName: this.props.userFriendlyName,
      applicationType: OIDC_APPLICATION,
      oidcProfile: oidcProfile,
      applicationId: this.props.applicationId
    }

    const constraints = {
      name: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_APPNAME
        }
      },
      userFriendlyName: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME
        }
      },
      oidcProfile: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_METADATA
        }
      },
    };
    const errors = validate(newMeta, constraints, {fullMessages: false});

    const duplicatedRedirectUri =
        duplicates(this.props.oidcProfile.oidcRedirectUris.slice().sort(),
            i => i.redirectUri).filter(i => i.redirectUri);
    const duplicatedClaims = duplicates([].concat.apply([], this.props.oidcProfile.oidcScope.map(scope =>
        scope.oidcCustomClaims.map(claim => claim.oidcCustomClaimName.toLowerCase()))));
    const duplicatedScope = duplicates(this.props.oidcProfile.oidcScope.map(scope => scope.scopeName.toLowerCase()));
    const emptyNameScope = this.props.oidcProfile.oidcScope.filter(scope => scope.scopeName.length === 0);
    const capabilities = JSON.parse(getMappedCapabilities());
    const epcsWorkflowsAssignedToPublicClient = capabilities[SBA_WORKFLOW_MAPPING]
        ? this.props.oidcProfile.oidcAcrWorkflows.filter(
            acrEl => acrEl.workflow.workflowCode === OIDC_WORKFLOW_NAME_EPCS &&
                this.props.oidcProfile.isPublicClient
        ) : [];
    const duplicatedAcrValue = duplicates(
        oidcProfile.oidcAcrWorkflows.map(acrEl => (acrEl.acrValue || '').toLowerCase())
    ).filter(v => v);
    const emptyAcrValue = this.props.oidcProfile.oidcAcrWorkflows
        .filter(acrEl => acrEl.acrValue.length === 0);

    if (errors) {
      this.setState({errors});
      this.props.setErrorMessage(errors[Object.keys(errors)[0]]);
    } else {
      if (duplicatedRedirectUri.length > 0) {
        this.props.setErrorMessage(messageConstants.OIDC_URI_IS_DUPLICATED);
      } else if (emptyNameScope.length > 0) {
        this.props.setErrorMessage(messageConstants.SCOPE_NAME_IS_EMPTY);
      } else if (duplicatedScope.length > 0) {
        this.props.setErrorMessage(duplicatedScope[0] + messageConstants.SCOPE_NAME_IS_DUPLICATED);
      } else if (duplicatedClaims.length > 0) {
        this.props.setErrorMessage(duplicatedClaims[0] + messageConstants.CLAIM_NAME_IS_DUPLICATED);
      } else if (duplicatedAcrValue.length > 0) {
        this.props.setErrorMessage(duplicatedAcrValue[0] + (messageConstants.ACR_VALUE_IS_DUPLICATED));
      } else if (epcsWorkflowsAssignedToPublicClient.length > 0) {
        this.props.setErrorMessage(messageConstants.EPCS_WORKFLOW_CANNOT_ASSIGNED_TO_PUBLIC_CLIENT);
      } else if (emptyAcrValue.length > 0) {
        this.props.setErrorMessage(messageConstants.ACR_VALUE_IS_EMPTY);
      } else {
        if (this.props.applicationId) {
          this.props.updateApp(newMeta);
        } else {
          this.props.addApp(newMeta);
        }
      }
    }
  }

  handleAddOidcCancel = () => {
    this.props.cancelAddApp();
  }

  handleEditApplication = () => {
    if (this.props.match.params.applicationId) {
      this.props.editAppId(this.props.match.params.applicationId);
    }
  }

  handleChangeAppName = (e) => {
    this.props.updateAppName(e.target.value);
  }
  handleChangeUserFriendlyName = (e) => {
    this.props.updateUserFriendlyName(e.target.value)
  }

  handleUserFriendlyNameBlur = () => {
    if (!this.props.userFriendlyName.length > 0) {
      this.props.updateUserFriendlyName(this.props.applicationName)
    }
  }

  handleSetApplicationId = () => {
    if (this.props.match.params.applicationId) {
      this.props.setAppId(this.props.match.params.applicationId);
    }
  }
  handleGetIdpMetadata = () => {
    this.props.getIdpMetadata();
  }
  handleGetWorkflows = () => {
    this.props.getWorkflows();
  }

  handleGetPredefinedAcrWorkflow = () => {
    this.props.getPredefinedAcrWorkflow();
  }
  handleShowModalOidcIdpMetadata = () => {
    this.props.showOidcIdpMetadataPopup();
  }
  handleHideModalOidcIdpMetadata = () => {
    this.props.hideOidcIdpMetadataPopup()
  }
  generateOidcClientCredentials = () => {
    this.props.generateOidcClientCredentials(this.props.applicationId)
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
      this.handleSetApplicationId();
      this.handleGetIdpMetadata();
      this.handleGetWorkflows();
      this.handleGetPredefinedAcrWorkflow();
      this.handleEditApplication();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  render() {
    const {oidcScope} = this.props;
    const capabilities = JSON.parse(getMappedCapabilities());
    const extendedAttributes = JSON.parse(getExtendedAttributes());
    const displayFlexibleAttributes = capabilities ? capabilities[SID_GUID_FLEXIBLE_ATTRIBUTES] : false;
    const displayUserExtendedAttributes = capabilities ? capabilities[USER_EXTENDED_ATTRIBUTES] : false;
    const displayNonLdapEpicUsername = capabilities ? capabilities[NON_LDAP_EPIC_USERNAME] : false;
    const displayConfigurableWorkflow = capabilities ? capabilities[SBA_WORKFLOW_MAPPING] : false;
    const {
      applicationName, userFriendlyName, oidcRedirectUris, clientId, clientSecret, applicationId, oidcProfile,
      successMsg, errorMsg, clearMessages, addOidcRedirectUri, deleteOidcRedirectUri, updateOidcRedirectUri,
      addScope, updateScope, deleteScope, addClaimToScope, deleteClaimFromScope, updateClaimInScope, workflows,
      defaultAcrWorkflows, predefinedAcrWorkflow, addConfigurableWorkflow, updateConfigurableWorkflow,
      deleteConfigurableWorkflow, updateIsPublicClient, showModalOidcIdpMetadata, idpMetadata,
      updateIsSingleLogoutEnabled, updateLogoutRedirectUri
    } = this.props;
    const isReady = !applicationId
      || (applicationId && oidcProfile && oidcProfile.clientId
        && workflows && workflows.length > 0 && predefinedAcrWorkflow && predefinedAcrWorkflow.length > 0)
    return (
        <div className="AddApp-container">
          {
            (isReady) ? (
              <div className="container">
                <Message successMessage={successMsg}
                         errorMessage={errorMsg}
                         clearMessages={clearMessages}/>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <div className="add-edit-title">{applicationId
                      ? messageConstants.OIDC_TITLE_EDIT
                      : messageConstants.OIDC_TITLE_ADD}</div>
                    <div className="add-edit-subtitle">
                      {messageConstants.OIDC_SUBTITLE}
                    </div>

                    <AppNames applicationName={applicationName}
                              userFriendlyName={userFriendlyName}
                              handleChangeAppName={this.handleChangeAppName}
                              handleChangeUserFriendlyName={this.handleChangeUserFriendlyName}
                              handleUserFriendlyNameBlur={this.handleUserFriendlyNameBlur}/>

                    <RedirectUris
                      oidcRedirectUris={oidcRedirectUris}
                      handleAddOidcRedirectUri={addOidcRedirectUri}
                      handleDelOidcRedirectUri={deleteOidcRedirectUri}
                      handleUpdateOidcRedirectUri={updateOidcRedirectUri}/>

                    <SingleLogout
                      isSingleLogoutEnabled={oidcProfile.isSingleLogoutEnabled}
                      logoutRedirectUri={oidcProfile.logoutRedirectUri}
                      updateIsSingleLogoutEnabled={updateIsSingleLogoutEnabled}
                      updateLogoutRedirectUri={updateLogoutRedirectUri}
                    />

                    &nbsp;
                    <CapabilitiesSection capabilities={capabilities}>
                      <h3 className="sba-subtitle">{messageConstants.CLAIMS_TITLE}</h3>
                      <Scope
                        extendedAttributes={extendedAttributes}
                        displayUserExtendedAttributes={displayUserExtendedAttributes}
                        displayFlexibleAttributes={displayFlexibleAttributes}
                        displayNonLdapEpicUsername={displayNonLdapEpicUsername}
                        oidcScope={oidcScope}
                        addScope={addScope}
                        updateScope={updateScope}
                        deleteScope={deleteScope}
                        addClaimToScope={addClaimToScope}
                        deleteClaimFromScope={deleteClaimFromScope}
                        updateClaimInScope={updateClaimInScope}/>

                      <ConfigurableWorkflow
                        oidcAcrWorkflows={oidcProfile.oidcAcrWorkflows}
                        workflows={workflows}
                        defaultAcrWorkflows={applicationId ? [] : defaultAcrWorkflows}
                        predefinedAcrWorkflow={predefinedAcrWorkflow}
                        displayConfigurableWorkflow={displayConfigurableWorkflow}
                        addConfigurableWorkflow={addConfigurableWorkflow}
                        updateConfigurableWorkflow={updateConfigurableWorkflow}
                        deleteConfigurableWorkflow={deleteConfigurableWorkflow}
                      />
                    </CapabilitiesSection>

                    &nbsp;
                    <ClientCredentials
                      applicationId={applicationId}
                      clientId={clientId}
                      clientSecret={clientSecret}
                      generateOidcClientCredentials={this.generateOidcClientCredentials}/>

                    <PublicClient
                      isPublicClient={oidcProfile.isPublicClient}
                      updateIsPublicClient={updateIsPublicClient}
                    />
                    &nbsp;

                    <h3 className="sba-subtitle">{messageConstants.SBA_METADATA_REQUIRED_SP}
                    </h3>

                    <div className="add-edit-subtitle">
                      {messageConstants.SBA_OIDC_METADATA_REQUIRED_SP_DESCRIPTION}
                    </div>
                    <div className="view-idp-metadata-block">
                      <button id="showModalOidcIdpMetadataButton"
                              className="btn btn-link view-idp-metadata-button"
                              onClick={this.handleShowModalOidcIdpMetadata}>{messageConstants.OIDC_IDP_VIEW_AND_COPY_METADATA}
                      </button>
                    </div>

                    <OidcIdpMetadataPopup
                      showModalOidcIdpMetadata={showModalOidcIdpMetadata}
                      handleHideModalOidcIdpMetadata={this.handleHideModalOidcIdpMetadata}
                      idpMetadata={idpMetadata}/>

                    <div className="action-row">
                      <button
                        id="cancelSaveOidcApplicationButton"
                        type="button"
                        className="btn btn-md cancel-save-button"
                        disabled={this.state.manualEntry}
                        onClick={this.handleAddOidcCancel}
                      >
                        {messageConstants.CANCEL}
                      </button>
                      &nbsp;
                      <button
                        id="saveOidcApplicationButton"
                        type="button"
                        className="btn btn-md btn-primary save-button"
                        disabled={!applicationName || !clientId
                          || !oidcRedirectUris.filter(e => e.redirectUri.length > 0).length > 0
                          || (oidcProfile.isSingleLogoutEnabled
                            && !(oidcProfile.logoutRedirectUri || '').trim())}
                        onClick={this.handleSaveSP}
                      >
                        {messageConstants.SBA_SAVE_BUTTON}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          }
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    errorMsg: state.sp.errorMsg,
    oidcProfile: state.sp.oidcProfile,
    oidcRedirectUris: state.sp.oidcRedirectUris,
    clientId: state.sp.clientId,
    clientSecret: state.sp.clientSecret,
    signature: state.sp.signature,
    applicationId: state.sp.applicationId,
    applicationName: state.sp.applicationName,
    userFriendlyName: state.sp.userFriendlyName,
    idpMetadata: state.idp,
    showModalOidcIdpMetadata: state.idp.showModalOidcIdpMetadata,
    oidcScope: state.sp.oidcScope,
    workflows: state.idp.workflows,
    predefinedAcrWorkflow: state.idp.predefinedAcrWorkflow,
    defaultAcrWorkflows: state.idp.defaultAcrWorkflows
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppName: (e) => {
      dispatch(spActions.updateAppName(e))
    },
    updateUserFriendlyName: (e) => {
      dispatch(spActions.updateUserFriendlyName(e))
    },
    addApp: (metadata) => {
      dispatch(spActions.addOidc(metadata));
    },
    updateApp: (metadata) => {
      dispatch(spActions.updateApp(metadata));
    },
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    },
    setAppId: (applicationId) => {
      dispatch(spActions.setAppId(applicationId));
    },
    editAppId: (applicationId) => {
      dispatch(spActions.getApp(applicationId))
    },
    addOidcRedirectUri: () => {
      dispatch(spActions.addOidcRedirectUri());
    },
    deleteOidcRedirectUri: (attribute) => {
      dispatch(spActions.deleteOidcRedirectUri(attribute));
    },
    updateOidcRedirectUri: (evt) => {
      dispatch(spActions.updateOidcRedirectUri(evt));
    },
    clearMessages: () => {
      dispatch(spActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(spActions.setErrorMessage(errorMessage))
    },
    getIdpMetadata: () => {
      dispatch(idpActions.getIdpMetadata());
    },
    showOidcIdpMetadataPopup: () => {
      dispatch(idpActions.showOidcIdpMetadataPopup());
    },
    hideOidcIdpMetadataPopup: () => {
      dispatch(idpActions.hideOidcIdpMetadataPopup());
    },
    generateOidcClientCredentials: (appId) => {
      dispatch(spActions.generateOidcClientCredentials(appId));
    },
    addScope: () => {
      dispatch(spActions.addScope());
    },
    updateScope: (updatedScopeIndex, updatedScope) => {
      dispatch(spActions.updateScope(updatedScopeIndex, updatedScope));
    },
    deleteScope: (scopeToDeleteIndex, scopeToDelete) => {
      dispatch(spActions.deleteScope(scopeToDeleteIndex, scopeToDelete));
    },
    updateIsPublicClient: (value) => {
      dispatch(spActions.updateIsPublicClient(value));
    },
    updateIsSingleLogoutEnabled: (value) => {
      dispatch(spActions.updateIsSingleLogoutEnabled(value));
    },
    updateLogoutRedirectUri: (value) => {
      dispatch(spActions.updateLogoutRedirectUri(value));
    },
    getWorkflows: () => {
      dispatch(idpActions.getWorkflows());
    },
    getPredefinedAcrWorkflow: () => {
      dispatch(idpActions.getPredefinedAcrWorkflow());
    },
    updateConfigurableWorkflow: (updatedIndex, toUpdate) => {
      dispatch(spActions.updateConfigurableWorkflow(updatedIndex, toUpdate));
    },
    deleteConfigurableWorkflow: (deleteIndex, toDelete) => {
      dispatch(spActions.deleteConfigurableWorkflow(deleteIndex, toDelete));
    },
    addConfigurableWorkflow: (toAdd) => {
      dispatch(spActions.addConfigurableWorkflow(toAdd));
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OidcApp);
